import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import settlement from './modules/settlement'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settlement
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js